import type { Readable as NodeReadable } from 'node:stream';
import { withResolvers } from './promises';

export function iterableFromReadable<T>(stream: ReadableStream<T>) {
  if (Symbol.asyncIterator in stream) {
    return (stream as any)[Symbol.asyncIterator]() as AsyncIterableIterator<T>;
  }

  return iterableFromReadableImpl(stream);
}

async function* iterableFromReadableImpl<T>(stream: ReadableStream<T>) {
  const reader = stream.getReader();

  while (true) {
    const item = await reader.read();

    if (item.done) {
      return;
    } else {
      yield item.value;
    }
  }
}

export async function nodeStreamToBuffer(stream: NodeReadable) {
  const chunks: Uint8Array[] = [];

  let length = 0;

  const deferred = withResolvers<Uint8Array>();

  stream
    .on('data', (chunk: Buffer) => {
      chunks.push(new Uint8Array(chunk.buffer, chunk.byteOffset, chunk.byteLength));
      length += chunk.byteLength;
    })
    .on('error', deferred.reject)
    .on('end', () => {
      const u8array = new Uint8Array(length);

      let offset = 0;

      for (const chunk of chunks) {
        u8array.set(chunk, offset);

        offset += chunk.byteLength;
      }

      deferred.resolve(u8array);
    });

  return deferred.promise;
}

export function streamDone(stream: ReadableStream) {
  const deferred = withResolvers<void>();

  stream.pipeTo(
    new WritableStream({
      close: deferred.resolve,
      abort: deferred.reject,
    }),
  );

  return deferred.promise;
}
